import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import ModalCustom from '../../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../../label-custom'
import Error_false from '../../../error/error-false'
import Error_500 from '../../../error/error-500'
import { createGroupsAPI } from '../../../../services/division'
import { useSelector } from 'react-redux'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'

const schema = yup
  .object({
    division: yup.string().required('Please, Input character of Group'),
    divisionEn: yup.string().required('Please, Input Group for English'),
    divisionTh: yup.string().required('Please, Input Group for Thai')
  })
  .required()
export default function AddDivsion({
  param,
  setIsSave,
  showCreate,
  isSave,
  fnGetData,
  setShowCreate,
  handleKeyDownTH,
  handleKeyDownEN,
  handleKeyDownNum
}) {
  const {
    control,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const orgId = useSelector((state) => state.roleReducer.role)

  const onSubmit = (d) => {
    const body = { ...param, orgId, ...d, larkEnable: d.larkEnable ?? false }

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create new?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createGroup(body)
      }
    })
  }

  const createGroup = async (body) => {
    try {
      const data = await createGroupsAPI(body)
      if (data?.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          fnGetData()
          setShowCreate(false)
        })
      } else {
        Error_false(data)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }

  const fnReset = () => {
    setError('division', false)
    setError('division_en', false)
    setError('division_th', false)
  }
  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }
  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label className="text-primary">Add Group</label>

        <Col md={12}>
          <LabelCustom text={'Group'} />
          <Controller
            name={'division'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={2}
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDownEN}
              />
            )}
          />
          {errors.division?.message && (
            <label className="small text-danger">
              {errors.division.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Group EN'} />
          <Controller
            name={'divisionEn'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownEN}
              />
            )}
          />
          {errors.divisionEn?.message && (
            <label className="small text-danger">
              {errors.divisionEn.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Group TH'} />
          <Controller
            name={'divisionTh'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownTH}
              />
            )}
          />
          {errors.divisionTh?.message && (
            <label className="small text-danger">
              {errors.divisionTh.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <Controller
            name={'larkEnable'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Group
                className="mb-3"
                controlId="formBasicCheckbox"
                value={value}
                onChange={onChange}
              >
                <Form.Check
                  checked={value}
                  type="checkbox"
                  label="Lark Enable"
                />
              </Form.Group>
            )}
          />
        </Col>

        <Col xl={12} className="text-center">
          <Button className="px-4 " disabled={isSave} type="submit">
            {isSave ? 'Saving...' : 'Save'}
          </Button>
          <Button
            className="px-4 text-primary me-2"
            variant="light"
            type="button"
            disabled={isSave}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
